import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// components
import useAuth from 'src/hooks/useAuth';

import ModalTags, { convertHexToColorName, getColorClass } from './ModalTags';

///
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import v2_actionCriarTag from 'src/actions/v2/chats/v2_actionCriarTag';
import v2_actionEditarTag from 'src/actions/v2/chats/v2_actionEditarTag';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarTag from 'src/actions/v2/chats/v2_actionDeletarTag';
import { fDate } from "src/utils/formatTime";

// Design System
import { Tag, Pencil, Trash2 } from 'lucide-react';
import { TAGS_COMPONENT_DESIGN } from './TagsComponent.design';

// ----------------------------------------------------------------------

export default function TagsComponent() {
  const { t } = useTranslation('settings');
  const { user } = useAuth();
  const [openDialogNovoSetor, setOpenDialogNovoSetor] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState('');
  ///// value fields
  const [tagId, setTagId] = useState('');
  const [listaTags, setListaTags] = useState([]);

  const [nome, setNome] = useState('');
  const [corHex, setCorHex] = useState('gray');

  async function buscarListaTags() {
    try {
      let querys = `?cliente_id=${user.clienteId}`
      const response = await v2_actionListaTagsChats(querys);
      setListaTags(response.data.data)
    } catch (error) {

    }
  }

  useEffect(() => {
    buscarListaTags()
  }, []);

  function applyFilter(tableData, filterName) {
    if (filterName) {
      tableData = tableData.filter(
        (item) =>
          item.nome.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
      );
    }
    return tableData;
  }

  async function handleCriarTag() {
    try {
      setLoading(true)
      const data = {
        nome: nome,
        cor_hex: corHex,
        usuario_id: user.id,
        cliente_id: user.clienteId
      }
      await v2_actionCriarTag(data);
      await buscarListaTags();
      setLoading(false)
      setOpenDialogNovoSetor(false);
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
    } catch (error) {
      setLoading(false)
    }
  }

  async function handleDeletarTag() {
    try {
      await v2_actionDeletarTag(tagId);
      await buscarListaTags();
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
      setOpenModalConfirmacao(false);

    } catch (error) {

    }

  }

  const handleEditarTag = async () => {
    try {
      await v2_actionEditarTag(tagId, { nome: nome, cor_hex: corHex });
      await buscarListaTags();
      setAction('');
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
      setOpenDialogNovoSetor(false);
    } catch (error) {
      console.log('error', error)
    }

  };

  const dataFiltered = applyFilter(listaTags, pesquisa);

  return (
    <div className={TAGS_COMPONENT_DESIGN.root} style={{ fontFamily: TAGS_COMPONENT_DESIGN.fontStack }}>
      <div className={TAGS_COMPONENT_DESIGN.stickyHeader}>
        <div className={TAGS_COMPONENT_DESIGN.container}>
          <div className={TAGS_COMPONENT_DESIGN.topbar}>
            <div className={TAGS_COMPONENT_DESIGN.topbarIdentity}>
              <div className="min-w-0">
                <h1 className={TAGS_COMPONENT_DESIGN.title}>{t('tags.header.title', 'Etiquetas')}</h1>
                <p className={TAGS_COMPONENT_DESIGN.subtitle}>
                  {t('tags.header.subtitle', 'Organize conversas e atendimentos com etiquetas.')}
                </p>
              </div>
            </div>
            <div className={TAGS_COMPONENT_DESIGN.topbarActions}>
              <button
                type="button"
                onClick={() => { setOpenDialogNovoSetor(true); setAction('Criar'); }}
                className={TAGS_COMPONENT_DESIGN.primaryButton}
              >
                {t('tags.header.createButton', 'Criar etiqueta')}
              </button>
            </div>
          </div>
        </div>
      </div>

      <ModalConfimacao
        open={openModalConfirmacao}
        onClose={() => {
          setOpenModalConfirmacao(false);
        }}
        onConfirm={handleDeletarTag}
        loadingFinalizar={loading}
        mensagem={t('tags.deleteConfirmMessage', 'Deseja mesmo excluir essa etiqueta?')}
      />

      <ModalTags
        open={openDialogNovoSetor}
        action={action}
        nome={nome}
        changeNome={(e) => {
          setNome(e.target.value)
        }}
        corHex={corHex}
        changeCorHex={(value) => {
          setCorHex(value)
        }}
        onSubmit={action === "Criar" ? handleCriarTag : handleEditarTag}
        onClose={() => {
          setOpenDialogNovoSetor(false);
          setNome('');
          setCorHex('gray'); // Nome da cor padrão
          setTagId('');
        }}
      />

      <div className={`${TAGS_COMPONENT_DESIGN.container} pt-6 ${TAGS_COMPONENT_DESIGN.pageBody}`}>
        <div className={TAGS_COMPONENT_DESIGN.stack}>
          <div className={TAGS_COMPONENT_DESIGN.sectionHeader}>
            <div className={TAGS_COMPONENT_DESIGN.sectionHeaderMain}>
              <h2 className={TAGS_COMPONENT_DESIGN.sectionHeaderTitle}>Lista</h2>
              <p className={TAGS_COMPONENT_DESIGN.sectionHeaderSub}>
                {t('tags.sectionSub', 'A cor ajuda a equipe a reconhecer a etiqueta no chat.')}
              </p>
            </div>
          </div>
          <div className={TAGS_COMPONENT_DESIGN.cardFlush}>
        {listaTags.length === 0 ? (
          <div className={TAGS_COMPONENT_DESIGN.emptyWrap}>
            <div className={TAGS_COMPONENT_DESIGN.emptyIcon}>
              <Tag size={28} />
            </div>
            <p className={TAGS_COMPONENT_DESIGN.emptyTitle}>{t('tags.emptyState.title', 'Nenhuma etiqueta criada')}</p>
            <p className={TAGS_COMPONENT_DESIGN.emptyDesc}>
              {t('tags.emptyState.description', 'Crie etiquetas para classificar e organizar seus contatos.')}
            </p>
            <button
              type="button"
              onClick={() => { setOpenDialogNovoSetor(true); setAction('Criar'); }}
              className={`${TAGS_COMPONENT_DESIGN.link} mt-4`}
            >
              {t('tags.emptyState.createButton', 'Criar minha primeira etiqueta')}
            </button>
          </div>
        ) : (
          <div className={TAGS_COMPONENT_DESIGN.tableWrap}>
            <div className={TAGS_COMPONENT_DESIGN.tableHeadRow}>
              <div className={`flex-1 min-w-[180px] pr-4 ${TAGS_COMPONENT_DESIGN.tableHead}`}>{t('tags.table.nameHeader', 'Etiqueta')}</div>
              <div className={`w-32 text-center ${TAGS_COMPONENT_DESIGN.tableHead}`}>{t('tags.table.colorHeader', 'Cor')}</div>
              <div className={`w-24 text-right ${TAGS_COMPONENT_DESIGN.tableHead}`}>{t('buttons.actions', { ns: 'common' })}</div>
            </div>
            {dataFiltered.map((row) => (
              <div key={row._id} className={TAGS_COMPONENT_DESIGN.tableRow}>
                <div className="flex-1 min-w-[180px] pr-4">
                  <p className={`${TAGS_COMPONENT_DESIGN.tableCell} font-semibold truncate`}>{row.nome}</p>
                  <p className={TAGS_COMPONENT_DESIGN.tableCellMuted}>{t('tags.table.createdAt', 'Criada em {{date}}', { date: fDate(row.date) })}</p>
                </div>
                <div className="w-32 flex justify-center">
                  <span className={`w-5 h-3 rounded-md ${getColorClass(row.cor_hex)}`} />
                </div>
                <div className="w-24 flex justify-end gap-1.5">
                  <button
                    type="button"
                    title={t('buttons.edit', { ns: 'common' })}
                    onClick={() => {
                      setOpenDialogNovoSetor(true);
                      setAction('Editar');
                      setTagId(row._id);
                      setNome(row.nome);
                      setCorHex(convertHexToColorName(row.cor_hex) || 'gray');
                    }}
                    className={TAGS_COMPONENT_DESIGN.iconButton}
                  >
                    <Pencil size={16} />
                  </button>
                  <button
                    type="button"
                    title={t('buttons.delete', { ns: 'common' })}
                    onClick={() => { setTagId(row._id); setOpenModalConfirmacao(true); }}
                    className={TAGS_COMPONENT_DESIGN.iconButtonDanger}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
          </div>
        </div>
      </div>
    </div>
  );
}
